import { Link } from 'react-router';
import './FileAccessRestrictedPage.css';

export interface FileAccessRestrictedPageProps {
  /** Primary CTA target. Default site home. */
  homeTo?: string;
  homeLabel?: string;
}

/**
 * Shown when a signed-in user opens a storage link they cannot read (403/404 collapsed).
 * Distinct from app-role `/access-denied`.
 */
export function FileAccessRestrictedPage({
  homeTo = '/',
  homeLabel = 'Back to home'
}: FileAccessRestrictedPageProps) {
  return (
    <div className="file-access-restricted">
      <h2 className="file-access-restricted__title">Access restricted</h2>
      <p className="file-access-restricted__body">
        You do not have access to this file. It may be unavailable, or your account may not have
        permission for this storage location.
      </p>
      <Link className="file-access-restricted__home" to={homeTo}>
        {homeLabel}
      </Link>
    </div>
  );
}
